import dayjs from 'dayjs';
import { dateStore } from '../store/dateStore';

export const SATELLITE_END_DATE = '2026-04-03T02:00:00';
export const IS_TAB_OPEN_DATE = '2026-03-16T00:00:00';

export const useDateHook = () => {
  const { today, setToday } = dateStore();

  const isOpenTabDate = () => {
    const targetDate = dayjs(IS_TAB_OPEN_DATE).subtract(1, 'second');

    return today.isAfter(targetDate);
  };

  // 온라인 세틀라이트 종료일
  const isSatelliteEnd = () => {
    const targetDate = dayjs(SATELLITE_END_DATE);

    return today.isAfter(targetDate);
  };

  const setTodayDate = () => {
    setToday(dayjs());
  };

  return {
    setTodayDate,
    isOpenTabDate,
    today,
    isSatelliteEnd,
    setToday,
  };
};
